<div class="search-form">

  <div *ngIf="displaySearchResults; else cameraView" class="flex flex-col">
    <span>search results</span><button (click)="displaySearchResults = false">back</button>

    <div *ngIf="searching &&  searchResults.length > 0; else noResults;">
      <div *ngFor="let vehicle of searchResults">
        <span>{{vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model}}</span>
      </div>
    </div>

    <ng-template #noResults>
      <span>No vehicle found</span>
    </ng-template>


    <div class="flex place-content-center place-items-center">
      Cool searching indicator here
    </div>
  </div>

  <ng-template #cameraView>
    <main id="camera">
      <!-- Camera view -->
      <video id="camera--view" autoplay playsinline #videoPlayer></video>
      <!-- Camera output -->
      <canvas class="hidden" id="camera--sensor" #imageCanvas></canvas>
      <!-- Camera trigger -->

    </main>
  </ng-template>
  <button [disabled]="displaySearchResults" id="camera--trigger" (click)="captureImage()">Scan Plate</button>
</div>